var map = {
	"./BottomNavigation.vue": "9e24",
	"./Category.vue": "0d32",
	"./CookieLayer.vue": "9244",
	"./DefaultHeader.vue": "345c",
	"./Diet.vue": "93f5",
	"./Dish.vue": "5fc4",
	"./GuestForm.vue": "3715",
	"./Hacks.vue": "abfc",
	"./Hero.vue": "2514",
	"./Info.vue": "8f33",
	"./InfoBubble.vue": "c109",
	"./InfoHeader.vue": "ee4e",
	"./InfoModal.vue": "7a06",
	"./Intolerance.vue": "ffea",
	"./LanguageSwitch.vue": "726d",
	"./Modal.vue": "714b",
	"./Program.vue": "b2d2",
	"./RangeSlider.vue": "5e69",
	"./Selector.vue": "8a7a",
	"./Styles.vue": "d193"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "953f";